import { standardInit } from "onload";

window.addEventListener("load", () => standardInit("generic"));
